<template>
  <div class="advanced-select">
    <div
      v-if="showSelect"
      :class="`select ${showOptions ? 'active' : ''}`"
      @click.prevent="handleSelectClick"
      @mousedown.prevent=""
    >
      <div class="select__value">
        {{ value ? value : prompt }}
      </div>
      <div v-if="!showOptions" class="select__chevron-icon-down">
        <bg-icon name="chevronDownNew"></bg-icon>
      </div>
      <div v-else class="select__chevron-icon-up">
        <bg-icon name="chevronDownNew"></bg-icon>
      </div>
    </div>
    <div v-if="showOptions" class="options">
      <div
        class="option option--add"
        @mousedown.prevent=""
        @click="handleAddClick"
      >
        <div class="text text--add">{{ addPrompt }}</div>
        <div class="action">
          <div class="action__add-icon">
            <bg-icon name="plus"></bg-icon>
          </div>
        </div>
      </div>
      <div
        v-for="(option, index) in opts"
        :key="index"
        class="option"
        @mousedown.prevent=""
      >
        <div
          class="text"
          :title="option.name"
          @click="handleOptionClick(option)"
        >
          {{ option.name }}
        </div>
        <div class="action action--edit" @click="handleEditClick(option)">
          <div class="action__edit-icon">
            <bg-icon name="pencil"></bg-icon>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showForm" class="select-form">
      <bg-input
        :placeholder="formPrompt"
        v-model="editableOption.name"
      ></bg-input>
      <div class="select-form__buttons-box">
        <div
          class="
            select-form__buttons-box__button
            select-form__buttons-box__button--confirm
          "
          @click="handleSaveClick"
        >
          <div class="select-form__buttons-box__button--confirm__wrapper">
            <bg-icon name="check"></bg-icon>
          </div>
        </div>
        <div
          class="
            select-form__buttons-box__button
            select-form__buttons-box__button--cancel
          "
          @click="handleCancelClick"
        >
          <div class="select-form__buttons-box__button--cancel__wrapper">
            <bg-icon name="close"></bg-icon>
          </div>
        </div>
        <div
          class="
            select-form__buttons-box__button
            select-form__buttons-box__button--remove
          "
          @click="handleDeleteClick"
        >
          <div class="select-form__buttons-box__button--remove__wrapper">
            <bg-icon name="trashcan"></bg-icon>
          </div>
        </div>
      </div>
    </div>
    <div v-if="multiple && chosenOptions.length > 0" class="tags-bubble">
      <div
        v-for="(tag, index) in chosenOptions"
        :key="index"
        class="tags-bubble__tag"
        @mousedown.prevent=""
      >
        <div class="tags-bubble__tag__text" :title="tag.name">
          {{ tag.name }}
        </div>
        <div class="tags-bubble__tag__close" @click="handleTagRemoval(tag)">
          <div class="tags-bubble__tag__close__icon_wrapper">
            <bg-icon name="closeTag"></bg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgInput from "@/components/bg-input";

export default {
  name: "AdvancedSelect",
  components: {
    BgIcon,
    BgInput,
  },
  data() {
    return {
      showOptions: false,
      showSelect: true,
      showForm: false,
      value: null,
      chosenOptions: [],
      editableOption: { name: "", value: "" },
      opts: this.options,
      localSelected: this.selected,
    };
  },
  props: {
    prompt: {
      type: String,
      default: "Select things",
    },
    addPrompt: {
      type: String,
      default: "Add thing",
    },
    formPrompt: {
      type: String,
      default: "Name the thing",
    },
    options: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    entity: {
      type: String,
      default: "thing",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    options() {
      this.opts = this.options;
      this.showSelected();
    },
    selected() {
      this.showSelected();
    },
  },
  methods: {
    handleSelectClick() {
      this.showOptions = !this.showOptions;
    },
    handleAddClick() {
      this.showForm = true;
      this.showOptions = false;
      this.showSelect = false;
      this.editableOption = { name: "", value: "" };
    },
    handleCancelClick() {
      this.closeFormShowSelect();
    },
    handleSaveClick() {
      if (this.editableOption.value === "") {
        this.options.push(this.editableOption);
        this.$emit("create", this.entity, this.editableOption);
      } else {
        this.$emit("update", this.entity, this.editableOption);
      }
      this.editableOption = { name: "", value: "" };
      this.closeFormShowSelect();
    },
    handleDeleteClick() {
      this.$emit("delete", this.entity, this.editableOption);
      this.closeFormShowSelect();
    },
    closeFormShowSelect() {
      this.showForm = false;
      this.showOptions = false;
      this.showSelect = true;
    },
    handleOptionClick(option) {
      if (!this.chosenOptions.includes(option)) {
        if (this.multiple) {
          this.chosenOptions.push(option);
        } else {
          this.chosenOptions = [option];
        }
        const ids = this.chosenOptions.map((tag) => {
          return tag.value;
        });
        this.$emit("change", this.entity, ids);
      }
      this.showForm = false;
      this.showOptions = false;
      this.showSelect = true;
    },
    handleEditClick(option) {
      this.showForm = true;
      this.showOptions = false;
      this.showSelect = false;
      this.editableOption = option;
    },
    handleTagRemoval(tag) {
      this.chosenOptions.splice(this.chosenOptions.indexOf(tag), 1);
      const ids = this.chosenOptions.map((tag) => {
        return tag.value;
      });
      this.$emit("change", this.entity, ids);
    },
    showSelected() {
      this.value = null;
      this.localSelected = this.selected;
      const selectedOptions = this.opts.filter((option) => {
        return this.localSelected.includes(option.value);
      });
      this.chosenOptions = selectedOptions;
      if (!this.multiple && selectedOptions.length > 0) {
        this.value = selectedOptions[0].name;
      }
    },
  },
  mounted() {
    const selectedOptions = this.opts.filter((option) => {
      return this.localSelected.includes(option.value);
    });
    this.chosenOptions = selectedOptions;
    if (!this.multiple && selectedOptions.length > 0) {
      this.value = selectedOptions[0].name;
    }
  },
};
</script>
